<template>
  <div class="container is-fluid">
    <div class="content content-padding">
      <div class="title-with-selector h1-selector">
        <h1 class="title">{{menu.languages[0].pivot.name}}</h1>
        <state-selector :selected="menu ? parseInt(menu.state_id) : null" 
                        :target="menu"
                        :update="'menu-slides'" 
        ></state-selector>
      </div>

      <div class="columns">
        <div class="column is-one-quarter">
          <div>
            <b>Cor de Fundo</b><br/>
            <div class="flex-container-center">
              {{menu.background_color}}
              <div class="color-preview" v-bind:style="{ backgroundColor: menu.background_color }"></div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter" v-if="showTextboxColor">
          <div>
            <b>Cor Caixa de Texto</b><br/>
            <div class="flex-container-center">
              {{menu.textbox_color}}
              <div class="color-preview" v-bind:style="{ backgroundColor: menu.textbox_color }"></div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div>
            <b>Cor do Texto</b><br/>
            <div class="flex-container-center">
              {{menu.text_color}}
              <div class="color-preview" v-bind:style="{ backgroundColor: menu.text_color }"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-multiline" v-if="menu.slug !== 'panorama'">
        <div class="column is-12" v-if="menu.background_path_1">
          <span><b>Background 1</b></span>
          <figure class="image coach-image">
            <img :src="coachImagePath + menu.background_path_1">
          </figure>
        </div>
        <div class="column is-12" v-if="menu.background_path_2">
          <span><b>Background 2</b></span>
          <figure class="image coach-image">
            <img :src="coachImagePath + menu.background_path_2">
          </figure>
        </div>
      </div>

      <a class="button is-primary" @click="editCoachEditCategoryModal">
        <span class="icon">
          <i class="fa fa-edit"></i>
        </span>
        <span>Editar</span>
      </a>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import CoachEditCategoryModal from '../Coach/CoachEditCategoryModal'
  import StateSelector from '../Util/StateSelector'
  import { BACKGROUND_IMG_PATH, MENUS } from '../../config'

  const CoachEditCategoryModalComponent = Vue.extend(CoachEditCategoryModal)

  export default {
    components: {
      StateSelector
    },

    props: ['menu'],

    data () {
      return {
        coachId: this.$store.state.route.params.id,
        coachImagePath: BACKGROUND_IMG_PATH
      }
    },

    mounted () {
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },
      showTextboxColor () {
        return MENUS.eraumavez !== parseInt(this.menu.id)
      }
    },

    methods: {
      editCoachEditCategoryModal () {
        let openCardModal = (propsData = {}) => {
          return new CoachEditCategoryModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Editar - ' + this.menu.languages[0].pivot.name,
          category_id: parseInt(this.menu.slide_category_id),
          coach_id: parseInt(this.coachId),
          categoryData: this.menu
        })
      }
    },

    watch: {
      currentEvent: function (val) {
      }
    }
  }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// MenuInfo.vue?631c518e